import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import "../assets/css/CompanySelectorModal.css";
import { useNavigate } from "react-router-dom";

const roles = [
  {
    role_id: 1,
    role_name: "Admin",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZUlkIjozOSwiY29tcGFueUlkIjo2LCJpYXQiOjE3NjkwNzYzMjIsImV4cCI6MTkyNjg2NDMyMn0.rYFkpHgZ3daT9RkLT6aEe13MLBEPMOA-IGdWDj5NVqA",
  },
  {
    role_id: 2,
    role_name: "HR",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZUlkIjo0MCwiY29tcGFueUlkIjo2LCJpYXQiOjE3NjkwNzY0ODMsImV4cCI6MTkyNjg2NDQ4M30.LpxcgcNKOx12hzQhv-wbIIaBbqiivCbMpXHY21zmGcI",
  },
  {
    role_id: 3,
    role_name: "Employee",
    accessToken:
      "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbXBsb3llZUlkIjo0MiwiY29tcGFueUlkIjo2LCJpYXQiOjE3NjkwNzY1MjQsImV4cCI6MTkyNjg2NDUyNH0.t6OZIWlb2MhZ1SHjw3K26aPsaMRi4p2nPIccwX6vUK0",
  },
];

const SwitchDemoRole = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const currentRole = localStorage.getItem("employee_role");
  const [selectedRole, setSelectedRole] = useState(null);
  const requestor_id = localStorage.getItem("requestor_id");

  const selectRole = (role) => {
    setSelectedRole(role);
    setError({});
  };

  const switchRole = async (selectedRole) => {
    if (!selectedRole.accessToken) {
      setError({ accessToken: "Access Toke not found !" });
    } else {
      setError({});
      const path = "/login/token?accessToken=";
      navigate(
        `${path}${selectedRole.accessToken}&requestor_id=${requestor_id}`
      );
    }
  };

  return (
    <Modal
      show={show}
      centered
      animation
      size="sm"
      className="company-selector-modal"
    >
      <Modal.Header>
        <Modal.Title>Select a Role</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {roles
          ?.filter((role) => role?.role_id != currentRole)
          .map((role) => (
            <div
              key={role?.role_id}
              className={`company-item ${
                selectedRole && selectedRole?.role_id === role?.role_id
                  ? "selected"
                  : ""
              }`}
              onClick={() => selectRole(role)}
            >
              <span>{role?.role_name}</span>
            </div>
          ))}

        {error?.accessToken && (
          <span className="text-danger">* {error?.accessToken}</span>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn-cancel" onClick={onHide}>
          Cancel
        </Button>
        <Button
          className="btn-continue"
          onClick={() => switchRole(selectedRole)}
        >
          Switch
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SwitchDemoRole;
